import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { FormService } from "../../utils/form.service";
import { AppService } from "../../utils/app.service";
import { ApiService } from '../../utils/api.service';
import { StateService } from '@uirouter/angular';
import { LocalStorageService } from 'angular-2-local-storage';
import { TokenCookieService } from '../../utils/token-cookie.service';
@Component({
    selector: 'ss-business-select',
    template: require('./business-select.html'),
})

export class BusinessSelectComponent implements OnInit {
    businessSelectionForm = {
        $submitting: false,
        $errorMsg: '',
        business_id: null,
        form: new FormGroup({
            business: new FormControl(['', Validators.required])
        })
    };
    loadingBusiness = true;
    businesses;
    constructor(
        private app: AppService,
        private formService: FormService,
        private apiService: ApiService,
        private stateService: StateService,
        private localStorageService: LocalStorageService,
        private tokenCookieService: TokenCookieService
    ) { }

    onBusinessSelect() {
        this.businessSelectionForm.$submitting = true;
        this.app.connectSelectedBusinessToSS(this.businessSelectionForm);
    };

    selectBusiness() {
        this.formService.submit(
            this.businessSelectionForm,
            null,
            this.onBusinessSelect.bind(this),
            null,
            null,
            null
        );
    }

    ngOnInit() {
        this.apiService.getBusinesses().then((res: any) => {
            this.businesses = res.filter(item => item.account.account_type == 'business' && item.business)
            if (this.businesses.length) {
                this.tokenCookieService.setTokenCookie();
                this.loadingBusiness = false;
            } else {
                this.stateService.go('ss_add_business');
            }
        }).catch(err => {
            let token_used = this.localStorageService.get('token_used');
            if (token_used === 'sso') {
                this.localStorageService.remove('access_token');
            } else if (token_used === 'portal') {
                this.localStorageService.remove('access_token');
                localStorage.removeItem('portal_r.access_token');
            }
            this.localStorageService.remove('token_used');
            this.stateService.go('ss_landing_state');
        })
    };
}
